import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import TopAppBar from "./components/TopAppBar";
import BottomNav from "./components/BottomNav";
import Home from "./components/Home";
import CrisisMode from "./components/CrisisMode";
import Library from "./components/Library";
import Tools from "./components/Tools";
import Journal from "./components/Journal";
import SupportNetwork from "./components/SupportNetwork";

function App() {
  return (
    <div className="app-shell">
      <BrowserRouter>
        <TopAppBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/crisis" element={<CrisisMode />} />
          <Route path="/library" element={<Library />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/support" element={<SupportNetwork />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <BottomNav />
      </BrowserRouter>
    </div>
  );
}

export default App;
